import Paragraph from "@components/Paragraph";
import { Text, View } from "dripsy";
import * as React from "react";

function TextNumberItem({
  title,
  subtitle,
  order,
  hasNumber,
}: {
  title: string;
  subtitle?: string;
  order?: number;
  hasNumber?: boolean;
}) {
  return (
    <View sx={{ my: "$1" }}>
      {hasNumber ? (
        <View
          sx={{
            width: 36,
            height: 36,
            backgroundColor: "$primary",
            borderRadius: 36,
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "$2",
          }}
        >
          <Text sx={{ color: "$background", fontSize: 16, fontWeight: "500" }}>{order}</Text>
        </View>
      ) : null}

      <Text sx={{ fontWeight: "500", fontSize: [15, 16, 17], marginBottom: "$1" }}>{title}</Text>
      {subtitle ? <Paragraph>{subtitle}</Paragraph> : null}
    </View>
  );
}
export default TextNumberItem;
